// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import { StrengthIndicatorWrapper } from './PasswordStrengthIndicator.styles';
import CopyParagraph from '../../Text/CopyParagraph/CopyParagraph';

function PasswordStrengthIndicator(props) {
  const { value } = props;

  const validatePassword = (val) => {
    // const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{12,})');
    const strongRegex = /'^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{12,})'/;
    const fairRegex = /'^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'/;
    if (strongRegex.test(val)) {
      return 'Strong';
    }
    if (fairRegex.test(val)) {
      return 'Fair';
    }
    if (val.length > 0) {
      return 'Weak';
    }

    return '';
  };

  return (
    <StrengthIndicatorWrapper className={validatePassword(value)}>
      <CopyParagraph className="label" color="tertiary" noMargins tagName="p">
        Password strength
      </CopyParagraph>
      <CopyParagraph className="strength" noMargins tagName="p">
        {validatePassword(value)}
      </CopyParagraph>
    </StrengthIndicatorWrapper>
  );
}

PasswordStrengthIndicator.propTypes = {
  value: PropTypes.string
};

PasswordStrengthIndicator.defaultProps = {
  value: ''
};

export default PasswordStrengthIndicator;
